/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Email_ChannelInputs */

const th_email_channel = /** @type {(inputs: Email_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อีเมล`)
};

const en_email_channel = /** @type {(inputs: Email_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const ja_email_channel = /** @type {(inputs: Email_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メール`)
};

const zh_email_channel = /** @type {(inputs: Email_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`电子邮件`)
};

const es_email_channel = /** @type {(inputs: Email_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo`)
};

const pt_email_channel = /** @type {(inputs: Email_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

const id_email_channel = /** @type {(inputs: Email_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const fr_email_channel = /** @type {(inputs: Email_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

const tl_email_channel = /** @type {(inputs: Email_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const vi_email_channel = /** @type {(inputs: Email_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const ko_email_channel = /** @type {(inputs: Email_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이메일`)
};

const de_email_channel = /** @type {(inputs: Email_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail`)
};

const ru_email_channel = /** @type {(inputs: Email_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эл. почта`)
};

const tr_email_channel = /** @type {(inputs: Email_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-posta`)
};

const it_email_channel = /** @type {(inputs: Email_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const pl_email_channel = /** @type {(inputs: Email_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

const uk_email_channel = /** @type {(inputs: Email_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ел. пошта`)
};

const hi_email_channel = /** @type {(inputs: Email_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ईमेल`)
};

const ar_email_channel = /** @type {(inputs: Email_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البريد الإلكتروني`)
};

const ms_email_channel = /** @type {(inputs: Email_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mel`)
};

const bn_email_channel = /** @type {(inputs: Email_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ইমেল`)
};

const zh_tw2_email_channel = /** @type {(inputs: Email_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`電子郵件`)
};

const zh_hk2_email_channel = /** @type {(inputs: Email_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`電子郵件`)
};

const ur_email_channel = /** @type {(inputs: Email_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ای میل`)
};

const fa_email_channel = /** @type {(inputs: Email_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ایمیل`)
};

const sw_email_channel = /** @type {(inputs: Email_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barua pepe`)
};

const nl_email_channel = /** @type {(inputs: Email_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

/**
* | output |
* | --- |
* | "Email" |
*
* @param {Email_ChannelInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const email_channel = /** @type {((inputs?: Email_ChannelInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_ChannelInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_email_channel(inputs)
	if (locale === "ja") return ja_email_channel(inputs)
	if (locale === "zh") return zh_email_channel(inputs)
	if (locale === "es") return es_email_channel(inputs)
	if (locale === "pt") return pt_email_channel(inputs)
	if (locale === "id") return id_email_channel(inputs)
	if (locale === "fr") return fr_email_channel(inputs)
	if (locale === "tl") return tl_email_channel(inputs)
	if (locale === "vi") return vi_email_channel(inputs)
	if (locale === "ko") return ko_email_channel(inputs)
	if (locale === "de") return de_email_channel(inputs)
	if (locale === "ru") return ru_email_channel(inputs)
	if (locale === "tr") return tr_email_channel(inputs)
	if (locale === "it") return it_email_channel(inputs)
	if (locale === "pl") return pl_email_channel(inputs)
	if (locale === "uk") return uk_email_channel(inputs)
	if (locale === "hi") return hi_email_channel(inputs)
	if (locale === "ar") return ar_email_channel(inputs)
	if (locale === "ms") return ms_email_channel(inputs)
	if (locale === "bn") return bn_email_channel(inputs)
	if (locale === "zh-TW") return zh_tw2_email_channel(inputs)
	if (locale === "zh-HK") return zh_hk2_email_channel(inputs)
	if (locale === "ur") return ur_email_channel(inputs)
	if (locale === "fa") return fa_email_channel(inputs)
	if (locale === "sw") return sw_email_channel(inputs)
	if (locale === "nl") return nl_email_channel(inputs)
	return en_email_channel(inputs)
});